import { render, staticRenderFns } from "./ColunasExportArrematantesSelect.vue?vue&type=template&id=895a4b60"
import script from "./ColunasExportArrematantesSelect.vue?vue&type=script&lang=js"
export * from "./ColunasExportArrematantesSelect.vue?vue&type=script&lang=js"
import style0 from "./ColunasExportArrematantesSelect.vue?vue&type=style&index=0&id=895a4b60&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports